export const EXPORT_EXTENSION = 'PDF'
